import SubscriptionStats      from "./section-two/SubscriptionStats"
import SubscriptionCards      from "./section-two/SubscriptionCards" 
 


const SubscriptionSectionTwo = ( { user, subscription }) => {
    return (
        <>              
            { subscription.paymentStatus ? <SubscriptionStats user={user} /> : <SubscriptionCards/> }
        </>
    )
}

export default SubscriptionSectionTwo
